import { render, staticRenderFns } from "./SettingsTabs.vue?vue&type=template&id=3799c53f&scoped=true&"
import script from "./SettingsTabs.vue?vue&type=script&lang=ts&"
export * from "./SettingsTabs.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsTabs.vue?vue&type=style&index=0&id=3799c53f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3799c53f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VRow})
